import React, { type FC, memo } from 'react';
import { getDuplicatePreviewUrl } from 'reactApp/modules/duplicates/duplicates.helpers';
import type { IDuplicatesPreviewItem } from 'reactApp/modules/duplicates/duplicates.types';
import { EStorageType } from 'reactApp/modules/storage/storage.types';
import { Link } from 'reactApp/ui/Link/Link';

interface IProps {
    rootClassName: string;
    imgClassName: string;
    items: IDuplicatesPreviewItem[];
    label: React.ReactNode;
    onClick: VoidFunction;
}

export const DuplicatesPreviewVariant4: FC<IProps> = memo(function DuplicatesPreviewVariant4(props: IProps) {
    const { rootClassName, imgClassName, label, items, onClick } = props;

    return (
        <Link id="duplicates" storage={EStorageType.duplicates} className={rootClassName} handleClick={onClick}>
            {label}
            {items.map((item, index) => (
                <img key={index} src={getDuplicatePreviewUrl(item)} className={imgClassName} />
            ))}
        </Link>
    );
});
